export default function EnterpriseHero() {
  return (
    <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://readdy.ai/api/search-image?query=Modern%20Swiss%20construction%20site%20with%20multiple%20professional%20trades%20working%20together%20on%20a%20large%20building%20project%2C%20coordinated%20team%20of%20specialists%20including%20electricians%20plumbers%20HVAC%20technicians%20and%20general%20contractors%2C%20professional%20equipment%20and%20tools%2C%20bright%20daylight%20with%20clean%20organized%20workspace%20showing%20excellent%20project%20management%20and%20teamwork&width=1920&height=1080&seq=enterprise-hero-bg&orientation=landscape"
          alt="Entreprise Générale - Coordination des Corps de Métier"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>
      
      <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-8 text-center w-full">
        <h1 className="text-5xl font-bold tracking-tight text-white sm:text-7xl mb-6">
          Entreprise Générale &amp; Expert CVSE
        </h1>
        <p className="mt-6 text-xl leading-8 text-white/95 max-w-3xl mx-auto">
          Découvrez la différence entre notre expertise technique spécialisée en installations CVSE et notre service complet d'entreprise générale avec coordination de tous les corps de métier.
        </p>
        <div className="mt-10 flex items-center justify-center gap-6">
          <a
            href="#comparison"
            className="rounded-full bg-teal-600 px-8 py-4 text-base font-semibold text-white shadow-lg hover:bg-teal-500 transition-all whitespace-nowrap cursor-pointer"
          >
            Comparer les Services
          </a>
          <a
            href="#contact"
            className="rounded-full bg-white/10 backdrop-blur-sm px-8 py-4 text-base font-semibold text-white border-2 border-white/30 hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
          >
            Nous Contacter
          </a>
        </div>
      </div>
    </section>
  );
}
